/**
 * For ADSK domains - noopener only. For non-ADSK domains - add noreferrer.
 * @param url
 * @return {string}
 */
export default url => 'noopener' + (/(?:\.|^)autodesk\.(?:com|eu)(?::\d+)?$/.test(new URL(url, window.location.origin).hostname) ? '' : ' noreferrer');
//# sourceMappingURL=getAnchorRel.js.map